/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Reset_Password_TitleInputs */

const de_login_reset_password_title = /** @type {(inputs: Login_Reset_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort zurücksetzen`)
};

/** @type {(inputs: Login_Reset_Password_TitleInputs) => LocalizedString} */
const en_login_reset_password_title = de_login_reset_password_title;

/**

* @param {Login_Reset_Password_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_reset_password_title = /** @type {((inputs?: Login_Reset_Password_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Reset_Password_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_reset_password_title(inputs)
	return en_login_reset_password_title(inputs)
});